/** Запись type=default из базы. Запасной набор, если /seo/public недоступен. */
export const SEO_DEFAULT = {
  id: 0,
  brand_id: 17,
  type: 'default',
  link: '',
  title: 'Масла и технические жидкости TCL - моторные масла и антифризы для автомобилей',
  h1: '',
  meta: 'Продукция TCL: японская продукция для автомобилей - моторные масла, антифризы и технические жидкости для автомобилей.',
  request: 'масла, антифризы, технические жидкости, моторные масла, антифризы для автомобилей, технические жидкости для автомобилей, японские масла, японские антифризы, японские технические жидкости, японская продукция',
}
